export const ToastStyles = {
  style: {
    borderRadius: "10px",
    background: "#333",
    color: "#fff",
  },
  duration: 3000,
};
